import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full w-[260px] flex-shrink-0 border-r border-[#E5E5E5] bg-[#DADDE2]"
}
const _hoisted_2 = { class: "flex flex-col gap-4 p-4 pt-6" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "h-[calc(100%-140px)] overflow-y-auto px-4" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center py-8"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-1"
}
const _hoisted_8 = { class: "mb-2 px-2 text-xs font-semibold uppercase tracking-wider text-[#6B7280]" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "min-w-0 flex-1" }
const _hoisted_11 = { class: "mt-0.5 truncate text-xs text-[#626468]" }
const _hoisted_12 = { class: "mt-1 flex items-center gap-1 text-xs text-[#6B7280]" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = {
  key: 0,
  class: "px-2 py-4 text-center"
}
const _hoisted_15 = { class: "text-sm text-[#6B7280]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.canViewHistory)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createCommentVNode(" Sidebar header "),
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "px-2 text-xl font-bold text-gray-800" }, "mobcall AURA™", -1 /* CACHED */)),
          _createElementVNode("button", {
            disabled: !$setup.canCreateConversation,
            class: _normalizeClass([
                    'flex items-center justify-center rounded-xl px-4 py-3 text-white transition-colors',
                    $setup.canCreateConversation
                        ? 'bg-[#242B59] hover:bg-[#1a203f]'
                        : 'cursor-not-allowed bg-gray-400',
                ]),
            onClick: $setup.createConversation
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString($setup.t('aura.chat.newChat')), 1 /* TEXT */)
          ], 10 /* CLASS, PROPS */, _hoisted_3)
        ]),
        _createCommentVNode(" Conversations list "),
        _createElementVNode("div", _hoisted_5, [
          _createCommentVNode(" Loading state "),
          ($props.isHistoryLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "h-6 w-6 animate-spin rounded-full border-2 border-[#242B59] border-t-transparent" }, null, -1 /* CACHED */)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString($setup.t('aura.chat.history')), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conversations, (conversation) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: conversation.id,
                    class: _normalizeClass([
                        'group flex w-full items-start gap-3 rounded-lg px-2 py-2 text-left transition-colors',
                        $setup.currentConversationId === conversation.id
                            ? 'bg-white shadow-sm'
                            : 'hover:bg-white/50',
                    ]),
                    onClick: ($event: any) => ($setup.selectConversation(conversation))
                  }, [
                    _createVNode($setup["ChatAltIcon"], {
                      class: _normalizeClass([
                            'mt-0.5 h-4 w-4 flex-shrink-0',
                            $setup.currentConversationId === conversation.id
                                ? 'text-[#48DDC3]'
                                : 'text-[#242B59]',
                        ])
                    }, null, 8 /* PROPS */, ["class"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", {
                        class: _normalizeClass([
                                'truncate text-sm font-medium',
                                $setup.currentConversationId === conversation.id
                                    ? 'text-[#242B59]'
                                    : 'text-[#242B59]',
                            ])
                      }, _toDisplayString(conversation.title || 'Untitled'), 3 /* TEXT, CLASS */),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(conversation.title || 'No messages'), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_12, [
                        _createVNode($setup["ClockIcon"], { class: "h-3 w-3" }),
                        _createTextVNode(" " + _toDisplayString($setup.formatRelativeDate(conversation.createdAt) || conversation.createdAt), 1 /* TEXT */)
                      ])
                    ]),
                    _createCommentVNode(" Delete button "),
                    ($setup.canDeleteConversation)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass([
                            'ml-1 flex-shrink-0 rounded p-1 opacity-0 transition-opacity',
                            'hover:bg-red-100 hover:text-red-600',
                            'group-hover:opacity-100',
                            'focus:opacity-100',
                        ]),
                          title: $setup.t('aura.chat.deleteConversation'),
                          onClick: _withModifiers(($event: any) => ($setup.deleteConversation(conversation)), ["stop"])
                        }, [
                          _createVNode($setup["TrashIcon"], { class: "h-4 w-4" })
                        ], 8 /* PROPS */, _hoisted_13))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */)),
                (!$setup.hasConversations)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString($setup.t('aura.conversation.noConversations')), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}